// extracted by mini-css-extract-plugin
export default {"container":"CommunityAutomationMainDiagram_container__gMgLv","arrowDown":"CommunityAutomationMainDiagram_arrowDown__T5pIr"};